"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#DBDDEB",
  d: "M5.755 3.722h10.489v10.216l-2.724.34V6.446H6.028l-.273-2.724Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 7h9v9H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5665A1",
  fillRule: "evenodd",
  d: "M4.99 3.7a.7.7 0 0 1 .7-.7H16.3a.7.7 0 0 1 .7.7v10.61a.7.7 0 0 1-.7.7h-2.174v1.29a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V6.574a.7.7 0 0 1 .7-.7h1.29V3.7Zm1.4 2.174h7.036a.7.7 0 0 1 .7.7v7.037H15.6V4.4H6.39v1.474Zm-1.99 1.4v5.203c1.926-.767 5.152-1.358 8.326-.415V7.274H4.4Zm8.326 6.258c-3.245-1.12-6.693-.328-8.32.472l-.006.003V15.6h8.326v-2.068Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5665A1",
  d: "M7.332 9.534a.777.777 0 1 1-1.554 0 .777.777 0 0 1 1.554 0Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ContentLibraryColorIcon20.js.map